export const kp_copy_notice = (target) => {
    const bodyRect = document.body.getBoundingClientRect(),
        linkRect = target.getBoundingClientRect(),
        linkOffsetY = linkRect.top - bodyRect.top,
        linkOffsetX = linkRect.left - bodyRect.left;

    const posX = linkOffsetX + (linkRect.width / 2) - 50
    const posY = linkOffsetY - 5 - 28;

    const notice = document.createElement('div')
    notice.innerHTML = 'Copied!'
    notice.classList.add('copy-notice')
    notice.style.left = `${posX}px`
    notice.style.top = `${posY}px`

    document.body.append(notice);

    const timer = setTimeout(() => {
        notice.style.opacity = '0'
    }, 2500)
}

export default {
    kp_copy_notice
}